module.exports = __webpack_public_path__ + "img/EASG_Energiekongress_2027_mobile.9ba2f153.jpg";